var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSociograma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5724_63167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.4042 122.845C105.14 122.845 127.625 100.361 127.625 72.6244C127.625 44.8882 105.14 22.4036 77.4042 22.4036C49.668 22.4036 27.1833 44.8882 27.1833 72.6244C27.1833 100.361 49.668 122.845 77.4042 122.845Z",
    fill: "#C9F4F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7389 16.8953H5.91944C3.69803 16.8953 1.89722 18.6961 1.89722 20.9175V37.8897C1.89722 40.1111 3.69803 41.9119 5.91944 41.9119H66.7389C68.9603 41.9119 70.7611 40.1111 70.7611 37.8897V20.9175C70.7611 18.6961 68.9603 16.8953 66.7389 16.8953Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7763 22.0161H13.3944C11.7115 22.0161 10.3472 23.3804 10.3472 25.0633V33.7425C10.3472 35.4254 11.7115 36.7897 13.3944 36.7897H23.7763C25.4593 36.7897 26.8236 35.4254 26.8236 33.7425V25.0633C26.8236 23.3804 25.4593 22.0161 23.7763 22.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5207 22.0161H31.1388C29.4558 22.0161 28.0916 23.3804 28.0916 25.0633V33.7425C28.0916 35.4254 29.4558 36.7897 31.1388 36.7897H41.5207C43.2037 36.7897 44.5679 35.4254 44.5679 33.7425V25.0633C44.5679 23.3804 43.2037 22.0161 41.5207 22.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2639 22.0161H48.8819C47.199 22.0161 45.8347 23.3804 45.8347 25.0633V33.7425C45.8347 35.4254 47.199 36.7897 48.8819 36.7897H59.2639C60.9468 36.7897 62.3111 35.4254 62.3111 33.7425V25.0633C62.3111 23.3804 60.9468 22.0161 59.2639 22.0161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7389 45.2244H5.91944C3.69803 45.2244 1.89722 47.0252 1.89722 49.2466V66.2188C1.89722 68.4402 3.69803 70.241 5.91944 70.241H66.7389C68.9603 70.241 70.7611 68.4402 70.7611 66.2188V49.2466C70.7611 47.0252 68.9603 45.2244 66.7389 45.2244Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7763 50.3467H13.3944C11.7115 50.3467 10.3472 51.711 10.3472 53.3939V62.0731C10.3472 63.756 11.7115 65.1203 13.3944 65.1203H23.7763C25.4593 65.1203 26.8236 63.756 26.8236 62.0731V53.3939C26.8236 51.711 25.4593 50.3467 23.7763 50.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5207 50.3467H31.1388C29.4558 50.3467 28.0916 51.711 28.0916 53.3939V62.0731C28.0916 63.756 29.4558 65.1203 31.1388 65.1203H41.5207C43.2037 65.1203 44.5679 63.756 44.5679 62.0731V53.3939C44.5679 51.711 43.2037 50.3467 41.5207 50.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2639 50.3467H48.8819C47.199 50.3467 45.8347 51.711 45.8347 53.3939V62.0731C45.8347 63.756 47.199 65.1203 48.8819 65.1203H59.2639C60.9468 65.1203 62.3111 63.756 62.3111 62.0731V53.3939C62.3111 51.711 60.9468 50.3467 59.2639 50.3467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.175 111.827L119.028 83.1616L120.528 83.8868L106.675 112.552L105.175 111.827Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.749 123.073L123.014 84.156L124.675 84.2954L121.41 123.212L119.749 123.073Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.846 126.96L110.46 125.763L110.899 124.155L115.285 125.352L114.846 126.96Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.749 117.924L138.815 104.86L139.519 106.371L111.452 119.435L110.749 117.924Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.239 85.1138L139.021 99.3944L138.682 101.026L69.9001 86.7456L70.239 85.1138Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6571 67.9287L121.407 76.9565L120.815 78.5144L97.0649 69.4866L97.6571 67.9287Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2128 68.6629L68.4073 84.3573L67.5652 82.9191L94.3707 67.2246L95.2128 68.6629Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9558 112.045L67.178 83.4341L68.794 83.842L61.5718 112.453L59.9558 112.045Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3351 111.643L82.724 131.781L81.5815 132.995L60.1926 112.856L61.3351 111.643Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.165 122.293L82.5404 133.126L81.7654 131.65L102.39 120.817L103.165 122.293Z",
    fill: "#17BEBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.929 108.523C145.787 108.523 148.103 106.207 148.103 103.349C148.103 100.492 145.787 98.1758 142.929 98.1758C140.072 98.1758 137.756 100.492 137.756 103.349C137.756 106.207 140.072 108.523 142.929 108.523Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.824 129.646C107.751 129.646 111.746 125.652 111.746 120.724C111.746 115.797 107.751 111.802 102.824 111.802C97.8962 111.802 93.9016 115.797 93.9016 120.724C93.9016 125.652 97.8962 129.646 102.824 129.646Z",
    fill: "#FF006B",
    stroke: "#FF006B",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.838 133.435C122.695 133.435 125.011 131.119 125.011 128.262C125.011 125.404 122.695 123.088 119.838 123.088C116.98 123.088 114.664 125.404 114.664 128.262C114.664 131.119 116.98 133.435 119.838 133.435Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.34,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.747 84.2257C125.745 84.2257 128.175 81.7956 128.175 78.7979C128.175 75.8002 125.745 73.3701 122.747 73.3701C119.75 73.3701 117.32 75.8002 117.32 78.7979C117.32 81.7956 119.75 84.2257 122.747 84.2257Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5389 136.994C84.5365 136.994 86.9666 134.564 86.9666 131.566C86.9666 128.568 84.5365 126.138 81.5389 126.138C78.5412 126.138 76.1111 128.568 76.1111 131.566C76.1111 134.564 78.5412 136.994 81.5389 136.994Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0111 90.0771C71.1315 90.0771 73.6611 87.5475 73.6611 84.4271C73.6611 81.3067 71.1315 78.7771 68.0111 78.7771C64.8907 78.7771 62.3611 81.3067 62.3611 84.4271C62.3611 87.5475 64.8907 90.0771 68.0111 90.0771Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7889 117.716C63.9093 117.716 66.4389 115.186 66.4389 112.066C66.4389 108.946 63.9093 106.416 60.7889 106.416C57.6685 106.416 55.1389 108.946 55.1389 112.066C55.1389 115.186 57.6685 117.716 60.7889 117.716Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2332 73.4103C98.3537 73.4103 100.883 70.8808 100.883 67.7603C100.883 64.6399 98.3537 62.1104 95.2332 62.1104C92.1128 62.1104 89.5833 64.6399 89.5833 67.7603C89.5833 70.8808 92.1128 73.4103 95.2332 73.4103Z",
    fill: "#17BEBB",
    stroke: "#17BEBB",
    strokeWidth: 4.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0288 55.5029C21.8288 54.7532 22.6803 52.6863 21.9307 50.8863C21.1811 49.0863 19.1142 48.2348 17.3141 48.9845C15.5141 49.7341 14.6626 51.801 15.4123 53.601C16.1619 55.401 18.2288 56.2525 20.0288 55.5029Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6708 56.9827C15.0542 56.9827 12.1208 59.9146 12.1208 63.5327C12.1208 64.4813 12.8903 65.2507 13.8389 65.2507H23.5014C24.45 65.2507 25.2195 64.4813 25.2195 63.5327C25.2195 59.916 22.2875 56.9827 18.6695 56.9827H18.6708Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.856 55.5029C39.656 54.7532 40.5075 52.6863 39.7578 50.8863C39.0082 49.0863 36.9413 48.2348 35.1413 48.9845C33.3413 49.7341 32.4898 51.801 33.2394 53.601C33.9891 55.401 36.056 56.2525 37.856 55.5029Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4987 56.9827C32.8821 56.9827 29.9487 59.9146 29.9487 63.5327C29.9487 64.4813 30.7182 65.2507 31.6668 65.2507H41.3293C42.2779 65.2507 43.0473 64.4813 43.0473 63.5327C43.0473 59.916 40.1154 56.9827 36.4973 56.9827H36.4987Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6856 55.5026C57.4856 54.753 58.3371 52.6861 57.5874 50.8861C56.8378 49.0861 54.7709 48.2346 52.9709 48.9842C51.1709 49.7338 50.3194 51.8007 51.069 53.6008C51.8187 55.4008 53.8856 56.2523 55.6856 55.5026Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3278 56.9827C50.7112 56.9827 47.7778 59.9146 47.7778 63.5327C47.7778 64.4813 48.5473 65.2507 49.4959 65.2507H59.1584C60.107 65.2507 60.8764 64.4813 60.8764 63.5327C60.8764 59.916 57.9445 56.9827 54.3264 56.9827H54.3278Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0286 27.0817C21.8286 26.3321 22.6801 24.2652 21.9304 22.4652C21.1808 20.6652 19.1139 19.8137 17.3139 20.5633C15.5139 21.313 14.6624 23.3799 15.412 25.1799C16.1617 26.9799 18.2286 27.8314 20.0286 27.0817Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6708 28.562C15.0542 28.562 12.1208 31.494 12.1208 35.112C12.1208 36.0606 12.8903 36.8301 13.8389 36.8301H23.5014C24.45 36.8301 25.2195 36.0606 25.2195 35.112C25.2195 31.4953 22.2875 28.562 18.6695 28.562H18.6708Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8557 27.0817C39.6557 26.3321 40.5072 24.2652 39.7576 22.4652C39.008 20.6652 36.9411 19.8137 35.141 20.5633C33.341 21.3129 32.4895 23.3799 33.2392 25.1799C33.9888 26.9799 36.0557 27.8314 37.8557 27.0817Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4987 28.5618C32.8821 28.5618 29.9487 31.4937 29.9487 35.1118C29.9487 36.0604 30.7182 36.8298 31.6668 36.8298H41.3293C42.2779 36.8298 43.0473 36.0604 43.0473 35.1118C43.0473 31.4951 40.1154 28.5618 36.4973 28.5618H36.4987Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6853 27.0815C57.4853 26.3318 58.3368 24.2649 57.5872 22.4649C56.8375 20.6649 54.7706 19.8134 52.9706 20.5631C51.1706 21.3127 50.3191 23.3796 51.0688 25.1796C51.8184 26.9796 53.8853 27.8311 55.6853 27.0815Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3278 28.562C50.7112 28.562 47.7778 31.494 47.7778 35.112C47.7778 36.0606 48.5473 36.8301 49.4959 36.8301H59.1584C60.107 36.8301 60.8764 36.0606 60.8764 35.112C60.8764 31.4953 57.9445 28.562 54.3264 28.562H54.3278Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.222,
    y: 61.416,
    width: 18.8889,
    height: 4.72222,
    rx: 2.36111,
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.111,
    y: 75.8604,
    width: 18.8889,
    height: 4.72222,
    rx: 2.36111,
    fill: "#A78CD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 81.1382,
    width: 18.8889,
    height: 4.72222,
    rx: 2.36111,
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.6111,
    y: 109.472,
    width: 18.8889,
    height: 4.72222,
    rx: 2.36111,
    fill: "#A78CD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.8057,
    y: 130.027,
    width: 18.8889,
    height: 4.72221,
    rx: 2.36111,
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.639,
    y: 126.833,
    width: 18.8889,
    height: 4.72222,
    rx: 2.36111,
    fill: "#6B3BAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5724_63167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(0 0.166016)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociograma);
export default __webpack_public_path__ + "static/media/sociograma.cbfa1133cdce25256f134d68e3cccebb.svg";
export { ForwardRef as ReactComponent };